<template>
  <div class="transport_number" :class="formGroupClass">
    <slot name="before"/>
    <div v-if="transport.errorType" class="form-fielderror trailer-error">
      <label>!</label>
      <div class="form-fielderror-text">
        <div>Грузовые автомобили и спецтехника должны оформляться в отдельной заявке</div>
      </div>
    </div>
    <label
      :for="inputId"
      class="control-label"
    >{{ inputLabel }}</label>
    <select
      class="form-control show-tick"
      :id="inputId"
      v-model="inputValue"
      :disabled="disabled"
      @input="emit"
      @change="emit"
      @blur="emit"
    >
      <template v-for="transportType in transportTypes">
        <option
          v-bind:key="transportType.id"
          v-if="transportType.id !== 'pedestrian' && Number(transportType.visible) === 1"
          :value="transportType.id"
        >{{ transportType.name }}
        </option>
      </template>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import transportInputMixin from '../../../../mixins/application-form/transportInputMixin'

export default {
  name: 'TransportTypeInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin,
    transportInputMixin
  ],

  props: {
    transportTypes: {
      type: Array,
      default: () => []
    },

    inputLabel: {
      default: 'Вид транспортного средства (ТС)'
    },

    inputName: {
      default: 'type'
    }
  },

  computed: {
    inputId () {
      return `form-visitor-transport-type-${this.visitorIndex}-${this.transportIndex}`
    }
  }
}
</script>
